function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 16C3.6 16 0 12.4 0 8C0 3.6 3.6 0 8 0C12.4 0 16 3.6 16 8C16 12.4 12.4 16 8 16Z",
  fill: "#3C3C3D"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.4008 3.97221L12.0168 4.35059C13.9155 6.39711 13.9155 9.53361 12.0168 11.5801L12.4008 11.9585C14.5139 9.70048 14.5139 6.22154 12.4008 3.96338V3.97221Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.32597 4.00487C6.40238 2.13341 9.5847 2.13341 11.6611 4.00487L12.045 3.62649C9.75388 1.54377 6.22425 1.54377 3.93311 3.62649L4.32597 4.00487Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.96754 11.5839C2.07118 9.53786 2.07118 6.40413 3.96754 4.35811L3.58364 3.97974C1.47049 6.2379 1.47049 9.71671 3.58364 11.9749L3.96754 11.5839Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.6573 11.9333C9.58087 13.8048 6.39855 13.8048 4.32214 11.9333L3.93823 12.3117C6.22938 14.3945 9.75901 14.3945 12.0502 12.3117L11.6573 11.9333Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.16225 7.00555C9.15588 7.76314 7.95764 7.67097 7.57672 7.67097L7.58794 6.33634C7.96886 6.33634 9.16887 6.21765 9.16225 7.00555ZM9.45801 9.07757C9.45105 9.90588 8.01507 9.81118 7.55746 9.81118L7.56981 8.34144C8.02742 8.3427 9.46528 8.21265 9.45801 9.07757ZM10.4239 6.70629C10.3538 5.91587 9.66577 5.65071 8.79339 5.5699L8.80255 4.48022H8.12762L8.11865 5.54844C7.94097 5.54844 7.75945 5.54844 7.57916 5.55475L7.58819 4.48022H6.9171L6.90789 5.57621H6.4784H5.54015L5.53415 6.28962C5.53415 6.28962 6.03275 6.28078 6.02501 6.28962C6.21206 6.26929 6.38047 6.39884 6.40603 6.58255L6.3808 9.5839C6.37153 9.71408 6.25732 9.81294 6.12559 9.80499C6.12483 9.80499 6.12406 9.80499 6.12329 9.80486C6.13218 9.81244 5.63244 9.80486 5.63244 9.80486L5.49153 10.6016H6.37097H6.85416L6.8448 11.7153H7.51972L7.52894 10.618H8.06837L8.05919 11.7102H8.7354L8.74465 10.6092C9.88544 10.541 10.6829 10.2632 10.7914 9.20889C10.8791 8.36038 10.4783 7.98158 9.83409 7.8288C10.2282 7.63182 10.4778 7.28459 10.4239 6.70629Z",
  fill: "white"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  x: 2,
  y: 2,
  width: 12,
  height: 12,
  fill: "white"
})));

var SvgWbtc = function SvgWbtc(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWbtc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wbtc.b88eb9c1.svg";
export { ForwardRef as ReactComponent };